export default {
  routerName: "management",
  routes: [
    {
      path: "/management/system-flow/create",
      component: () => import("../management-system-flow-form"),
    },
    {
      path: "/management/system-flow/:id",
      component: () => import("../management-system-flow-form"),
    },
    {
      path: "/management/system-flow",
      component: () => import("../management-system-flow-view"),
    },
  ],
};
